// # 사건 → 다시 받을 조회
//
// 바뀜 사건(이름·핀·이모지·그룹·사람)은 값을 싣지 않는다 — 소켓은 알림이고 진실은 REST 에 있다.
// 받은 화면은 해당 조회 캐시를 낡았다고 표시해 다시 받는다. 어떤 사건이 어떤 캐시를 낡게 하는지를
// 앱 화면 곳곳에 흩지 않고 여기 한 곳에 둔다 — 열쇠 이름이 어긋나면 화면이 조용히 안 바뀐다.

import type { Event } from '@maru/protocol'

/** TanStack Query 의 열쇠 앞머리. 앞머리가 같으면 그 밑이 전부 낡는다. */
export type QueryKeyPrefix = readonly unknown[]

/** 이 사건이 낡게 만드는 조회들. 없으면 빈 배열. */
export function stale_queries(e: Event): QueryKeyPrefix[] {
  switch (e.t) {
    // 종류(공개↔비공개)·이름·주제·보관 — 사이드바 자리와 글자가 달라진다.
    case 'kind_changed':
    case 'channel_changed':
      return [['channels']]
    case 'pins_changed':
      return [['pins', e.channel]]
    case 'emoji_changed':
      return [['emoji']]
    case 'groups_changed':
      return [['groups']]
    // 이름·역할은 명단에, 직함·상태는 프로필에, 그 사람 한 줄은 `['member', id]` 에 있다.
    case 'member_changed':
      return [['members'], ['profiles'], ['member', e.who]]
    default:
      return []
  }
}
